import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ResultsNumbers } from '../components/results/ResultsNumbers';
import { ResultsWhatTheySaid } from '../components/results/ResultsWhatTheySaid';
import { ResultsCaseStudies } from '../components/results/ResultsCaseStudies';
import { ResultsMoreVoices } from '../components/results/ResultsMoreVoices';
import { ResultsClosingCta } from '../components/results/ResultsClosingCta';
export function ResultsPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-509" data-mp="1io3nayhkpte9">
      <Navigation data-id="element-510" data-mp="14qf0vm7uye73" />
      <main className="flex-grow" data-id="element-511" data-mp="14ou5judpyr86">
        <ResultsNumbers data-id="element-512" data-mp="14rq7dtsou01w" />
        <ResultsWhatTheySaid data-id="element-513" data-mp="19ogl4ah0sjk5" />
        <ResultsCaseStudies data-id="element-514" data-mp="19nnmxxw4n2dm" />
        <ResultsMoreVoices data-id="element-515" data-mp="19mvrcn2j54nc" />
        <ResultsClosingCta data-id="element-516" data-mp="3pfuq4crfhuum" />
      </main>
      <Footer data-id="element-517" data-mp="3pf32pp7zj3ff" />
    </div>;
}